import React from  "react";

const Gymnastics = (props) => {


   return (
      <section className="feature">
           <div className="feature-description">
               <h1>Gymnastics</h1>
                  <li>I have been on a trampoline since the age of two, but my gymnastics career officially began at the age of 10.</li>
                  <li>2010 National Champion</li>
                  <li>Three years on the USA National Team (2012, 2019, 2020)</li>
                  <li>Invited to participate in the 2016 & 2020 Olympic Trials</li>
                  <li>I have competed in Bulgaria, Spain, Portugal, and Japan</li>
                  <li>2019 VIP Classic - Bronze Medalist (Evansville, Indiana) </li>
                  <li>2019 Elite Challenge - Silver Medalist (Salem, North Carolina) </li>
                  <li>2019 National Championships - Silver Medalist (Des Moines, Iowa)</li>
                  <li>2019 Loule World Cup - Gold & Silver Medalist (Loule, Portugal)</li>
                  <li><strong>2019 World Championships - Silver Medalist (Tokyo, Japan)</strong></li>
         </div>
      </section>
   )
}
export default Gymnastics;